import script from "./TopNamesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNamesPage.vue?vue&type=script&lang=ts&setup=true"

import "./TopNamesPage.vue?vue&type=style&index=0&id=765e8e8d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765e8e8d"]])

export default __exports__